import Image from "./applicationsMonitoring.svg";
function ApplicationMonitorIcon() {
  const style = {
    width: "21px",
    height: "27px",
  };
  return <img src={Image} alt="" style={style} />;
}

export default ApplicationMonitorIcon;
